import * as React from "react"
import { Container } from 'react-bootstrap'

import Layout from "../components/layout"
import Seo from "../components/seo"
import 'bootstrap/dist/css/bootstrap.min.css';

const IndexPage = () => (
  <Layout>
    <Seo title="References" />
    <Container style={{ minHeight: 400 }}>

		<h1>Sources</h1>

		<section>
			<ol>
				<li>
					<a
						href="https://linc.nus.edu.sg/record=b2579153"
						target="_blank"
						rel="noreferrer"
					>
					黄美萍，钟伟耀，林永美编 (Huang, Zhong and Lin Eds.). (2007). 新加坡宗乡会馆出版书刊目录 (A Bibliography on the Publications of Singapore Chinese Clan Associations). 新加坡 : 新加坡国家图书馆管理局 (Singapore: National Library Board).
					</a>
				</li>
				<li>
					Singapore Federation of Chinese Clan Associations. (2012). Members' Directory. Retrieved from&nbsp;
					<a
						href="http://www.sfcca.sg/en/member/classes"
						target="_blank"
						rel="noreferrer"
					>
						http://www.sfcca.sg/en/member/classes
					</a>
					&nbsp;on 21 July 2015.
				</li>
			</ol>
		</section>

    </Container>
  </Layout>
)

export default IndexPage
